"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function escapeRegExp(e) {
  return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}function extractRouteSections(e) {
  var t = e.match(routeQueryStringRegex),
      n = t ? t.index + 1 : e.length,
      r = [e.slice(0, n), e.slice(n + 1, e.length)];return { path: r[0] ? r[0].split("/").splice(1).map(function (e) {
      return decodeURIComponent(e);
    }) : null, query: r[1] ? r[1].split("&").map(function (e) {
      var t = e.split("=");return { key: decodeURIComponent(t[0]), value: !t[1] || decodeURIComponent(t[1]) };
    }) : null };
}var Component = require("./Component.js"),
    common = require("./common.js"),
    objectHash = require("./objectHash.js"),
    Emitter = require("./Emitter.js");var routeParameterRegex = /{(.+?)}/g,
    routeQueryStringRegex = /[^{]\?[^}]/;
var Router = function (_Emitter) {
  _inherits(Router, _Emitter);

  function Router() {
    var _this;

    _classCallCheck(this, Router);

    (_this = _possibleConstructorReturn(this, (Router.__proto__ || Object.getPrototypeOf(Router)).call(this)), _this), _this.reset(), window.addEventListener("popstate", function () {
      _this.update();
    }, !1);return _this;
  }

  _createClass(Router, [{
    key: "reset",
    value: function reset() {
      this.resolveTree = {}, this.routeDictionary = {}, this.parentContainer = null, this.paramHash = null, this.currentNode && this.currentNode.cleanup && this.currentNode.cleanup(), this.currentNode = null;
    }
  }, {
    key: "register",
    value: function register(e, t) {
      var _this2 = this;

      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if ("string" == typeof e && (e = [e]), !"true") {
        var _n = !1;if (e && Array.isArray(e)) {
          _n = !0;for (var _t = 0; _t < e.length && _n; _t++) {
            _n = "string" == typeof e[_t] && 0 === e[_t].indexOf("/");
          }
        }if (!_n) throw new Error("Invalid parameter for routes has been passed to Router.register: " + e + ".");var r = !1,
            o = t.__proto__;for (; !r && null != o;) {
          o === Component ? r = !0 : o = o.__proto__;
        }
      }
      var _loop = function _loop(_r) {
        var o = extractRouteSections(e[_r]);if (!"true") {
          if (!o) throw new Error("Error while creating route object for '" + e[_r] + "'");if (o.query && o.query.length > 0) throw new Error("A query string is not valid as a definition for a route: '" + e[_r] + "'. Route will never resolve.");
        }var i = _this2.resolveTree;for (var _t2 = 0; _t2 < o.path.length; _t2++) {
          var _n2 = o.path[_t2].toLowerCase(),
              _s = routeParameterRegex.exec(_n2);if (_s) {
            var _t3 = void 0,
                _o = "",
                a = [],
                l = [],
                u = 0;do {
              _o += escapeRegExp(_t3 = _n2.slice(u, _s.index)), l.push(_t3);var _i = _s[1],
                  _p = !1,
                  c = _i.indexOf("?");if (_p = -1 !== c) {
                if (!"true" && c !== _i.length - 1) throw new Error("Error while parsing route for '" + e[_r] + "'. '?' is a reserved character and cannot be used in paramter IDs.");_i = _i.slice(0, _i.length - 1);
              }var d = _i.split(":"),
                  h = null;_i = d[0], null == d[1] && (d[1] = "any");var f = void 0,
                  m = _i.indexOf("?");switch ((f = m === _i.length - 1) && (_i = _i.substr(0, m)), d[1]) {case "number":
                  h = "([d.]" + (f ? "+" : "*") + ")";break;case "any":case "string":
                  h = "(." + (f ? "+" : "*") + ")";break;default:
                  if (!"true") throw new Error("Unknown route data type found for '" + e[_r] + "': " + d[1]);}_o += h, _p && (_o += "?"), a.push(_i), u = _s.index + _s[0].length;
            } while (null != (_s = routeParameterRegex.exec(_n2)));_t3 = _n2.slice(u), l.push(_t3), _o += escapeRegExp(_t3), i._regexNodes || (i._regexNodes = []);var p = i;i._regexNodes.push(i = new RegExp(_o)), i._routeParamNames = a, i._routeParamSections = l, i._parent = p;
          } else i[_n2] || (i[_n2] = { _parent: i, _nodeName: _n2 }), i = i[_n2];
        }"string" != typeof n && "function" != typeof n || (n = { title: n });var s = null;n.cleanup = function () {
          var e = s.detach();return e && (s = null), e;
        }, n.handler = function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
            var r;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    s = new t();
                    "true" || (window.currentComponent = s);
                    _context.t0 = "function" == typeof n.preRenderAsync;

                    if (!_context.t0) {
                      _context.next = 6;
                      break;
                    }

                    _context.next = 6;
                    return n.preRenderAsync(s, e);

                  case 6:
                    s.attach(_this2.parentContainer);
                    r = n.title;
                    "function" == typeof r && (r = r(e));
                    r && (document.title = r);

                    if (!("function" == typeof n.renderAsync)) {
                      _context.next = 15;
                      break;
                    }

                    _context.next = 13;
                    return n.renderAsync(e, s.renderAsync.bind(s));

                  case 13:
                    _context.next = 22;
                    break;

                  case 15:
                    if (!("function" == typeof n.render)) {
                      _context.next = 20;
                      break;
                    }

                    _context.next = 18;
                    return new Promise(function (t) {
                      "true" || s.async, n.render(e, (s.async ? s.renderAsync : s.render).bind(s));
                    });

                  case 18:
                    _context.next = 22;
                    break;

                  case 20:
                    _context.next = 22;
                    return s.renderAsync(e);

                  case 22:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, _this2);
          }));

          return function (_x2) {
            return _ref.apply(this, arguments);
          };
        }(), n.inlineUpdate = function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if (!("function" == typeof s.updateParamsAsync)) {
                      _context2.next = 5;
                      break;
                    }

                    _context2.next = 3;
                    return s.updateParamsAsync(e);

                  case 3:
                    _context2.next = 6;
                    break;

                  case 5:
                    "function" == typeof s.updateParams && s.updateParams(e);

                  case 6:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, _this2);
          }));

          return function (_x3) {
            return _ref2.apply(this, arguments);
          };
        }(), i._options = n, _this2.routeDictionary[t] ? _this2.routeDictionary[t].push(i) : _this2.routeDictionary[t] = [i];
      };

      for (var _r in e) {
        _loop(_r);
      }return t;
    }
  }, {
    key: "attach",
    value: function attach(e) {
      return this.parentContainer = common.select(e), this.update();
    }
  }, {
    key: "update",
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "" + window.location.pathname + window.location.search;
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.resolve(e);
        "true";var n, r, o;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                n = !0;

                if (!t) {
                  _context3.next = 27;
                  break;
                }

                _context3.prev = 2;
                r = !1, o = objectHash(t.params, !1, t.node._options.inlineParams);
                this.currentNode === t.node && (r = o === this.paramHash);

                if (!r) {
                  _context3.next = 10;
                  break;
                }

                _context3.next = 8;
                return this.currentNode._options.inlineUpdate(t.params);

              case 8:
                _context3.next = 19;
                break;

              case 10:
                this.paramHash = o;
                this.currentNode && (n = this.currentNode._options.cleanup());
                _context3.t0 = n;

                if (!_context3.t0) {
                  _context3.next = 19;
                  break;
                }

                this.currentNode = t.node;
                _context3.next = 17;
                return this.currentNode._options.handler(t.params);

              case 17:
                _context3.next = 19;
                return this.currentNode._options.inlineUpdate(t.params);

              case 19:
                n && this.emit("updated", e);
                _context3.next = 25;
                break;

              case 22:
                _context3.prev = 22;
                _context3.t1 = _context3["catch"](2);
                this.emit("error", _context3.t1), n = !1;

              case 25:
                _context3.next = 28;
                break;

              case 27:
                this.emit("unresolved", e), n = !1;

              case 28:
                return _context3.abrupt("return", n);

              case 29:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 22]]);
      }));

      function update() {
        return _ref3.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "resolve",
    value: function resolve(e) {
      if (!"true" && null == e) throw new Error("Cannot resolve a null/undefined path");var t = extractRouteSections(e),
          n = this.resolveTree,
          r = {};for (var _e = 0; _e < t.path.length; _e++) {
        var _i2 = t.path[_e];if (_i2) var o = _i2.toLowerCase();if (null != n[o]) n = n[o];else {
          if (!n._regexNodes) return null;{
            var _e2 = null;for (var _t4 = 0; _t4 < n._regexNodes.length; _t4++) {
              if (_e2 = n._regexNodes[_t4].exec(_i2)) {
                n = n._regexNodes[_t4];for (var _t5 = 0; _t5 < n._routeParamNames.length; _t5++) {
                  r[n._routeParamNames[_t5]] = _e2[_t5 + 1];
                }break;
              }
            }if (!_e2) return null;
          }
        }
      }var i = null;if (n._options) {
        if (t.query && t.query.length) for (var _e3 = 0; _e3 < t.query.length; _e3++) {
          r[t.query[_e3].key] = t.query[_e3].value;
        }i = { node: n, params: r };
      }return i;
    }
  }, {
    key: "link",
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var n, r, o, i, _e4, _t6, _r2, s, _e5, _n3, _i3, _r3, _o2, a, _e6;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if ("true") {
                  _context4.next = 5;
                  break;
                }

                if (!(null == e)) {
                  _context4.next = 3;
                  break;
                }

                throw new Error("A null/undefined id is not allowed");

              case 3:
                if (!(null == this.routeDictionary[e])) {
                  _context4.next = 5;
                  break;
                }

                throw new Error("Route is not defined for id: '" + e + "'");

              case 5:
                n = this.routeDictionary[e], r = null, o = Object.keys(t), i = null;
                for (_e4 = 0; _e4 < n.length; _e4++) {
                  _t6 = void 0;
                  if (n[_e4]._routeParamNames) {
                    _t6 = 0;for (_r2 = 0; _r2 < n[_e4]._routeParamNames.length; _r2++) {
                      -1 === o.indexOf(n[_e4]._routeParamNames[_r2]) && _t6++;
                    }
                  } else _t6 = o.length;(_t6 < i || null == i) && (r = n[_e4], i = _t6);
                }
                if (!(!"true" && !r)) {
                  _context4.next = 9;
                  break;
                }

                throw new Error("Unable to resolve a route for id: '" + e + "'");

              case 9:
                s = null;
                "function" == typeof r._options.preLinkResolve && (s = r._options.preLinkResolve(t));
                _context4.t0 = "function" == typeof r._options.preLinkResolveAsync;

                if (!_context4.t0) {
                  _context4.next = 16;
                  break;
                }

                _context4.next = 15;
                return r._options.preLinkResolveAsync(t);

              case 15:
                s = _context4.sent;

              case 16:
                if (s) {
                  _context4.next = 28;
                  break;
                }

                _e5 = r, _n3 = [], _i3 = { length: 0 };
                for (; null != _e5._parent;) {
                  if (_e5 instanceof RegExp) {
                    _r3 = "", _o2 = 0;
                    for (; _o2 < _e5._routeParamNames.length; _o2++) {
                      t[_e5._routeParamNames[_o2]] && (_r3 += "" + _e5._routeParamSections[_o2] + t[_e5._routeParamNames[_o2]], _i3[_e5._routeParamNames[_o2]] = !0, _i3.length++);
                    }_n3.push(encodeURIComponent("" + _r3 + _e5._routeParamSections[_o2]));
                  } else _n3.unshift(encodeURIComponent(_e5._nodeName));_e5 = _e5._parent;
                }s = "/" + _n3.join("/");a = [];
                if (_i3.length < o.length) {
                  for (_e6 = 0; _e6 < o.length; _e6++) {
                    _i3[o[_e6]] || a.push(encodeURIComponent(o[_e6]) + "=" + encodeURIComponent(t[o[_e6]]));
                  }a.length > 0 && (s += "?" + a.join("&"));
                }"function" == typeof r._options.postLinkResolve && (s = r._options.postLinkResolve(t, s));
                _context4.t1 = "function" == typeof r._options.postLinkResolveAsync;

                if (!_context4.t1) {
                  _context4.next = 28;
                  break;
                }

                _context4.next = 27;
                return r._options.postLinkResolve(t, s);

              case 27:
                s = _context4.sent;

              case 28:
                return _context4.abrupt("return", s);

              case 29:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function link(_x6) {
        return _ref4.apply(this, arguments);
      }

      return link;
    }()
  }, {
    key: "push",
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var n, _e7;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.link(e, t);

              case 2:
                n = _context5.sent;

                if (!this.parentContainer) {
                  _context5.next = 21;
                  break;
                }

                _e7 = void 0;

                if (!(n === "" + window.location.pathname + window.location.search)) {
                  _context5.next = 10;
                  break;
                }

                _context5.next = 8;
                return this.update(n);

              case 8:
                _context5.next = 19;
                break;

              case 10:
                if (!(_e7 = this.resolve(n))) {
                  _context5.next = 18;
                  break;
                }

                _context5.next = 13;
                return this.update(n, _e7);

              case 13:
                _context5.t0 = _context5.sent;

                if (!_context5.t0) {
                  _context5.next = 16;
                  break;
                }

                history.pushState(t, "", n);

              case 16:
                _context5.next = 19;
                break;

              case 18:
                window.location.href = n;

              case 19:
                _context5.next = 22;
                break;

              case 21:
                window.location.href = n;
              case 22:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function push(_x8) {
        return _ref5.apply(this, arguments);
      }

      return push;
    }()
  }]);

  return Router;
}(Emitter);

module.exports = new Router();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJvdXRlci5qcyJdLCJuYW1lcyI6WyJDb21wb25lbnQiLCJyZXF1aXJlIiwiY29tbW9uIiwib2JqZWN0SGFzaCIsIkVtaXR0ZXIiLCJlc2NhcGVSZWdFeHAiLCJzdHIiLCJyZXBsYWNlIiwicm91dGVQYXJhbWV0ZXJSZWdleCIsInJvdXRlUXVlcnlTdHJpbmdSZWdleCIsImV4dHJhY3RSb3V0ZVNlY3Rpb25zIiwicm91dGUiLCJtYXRjaCIsInF1ZXJ5U3RyaW5nUG9zaXRpb24iLCJpbmRleCIsImxlbmd0aCIsInVybFNlY3Rpb25zIiwic2xpY2UiLCJwYXRoIiwic3BsaXQiLCJzcGxpY2UiLCJtYXAiLCJzZWN0aW9uIiwiZGVjb2RlVVJJQ29tcG9uZW50IiwicXVlcnkiLCJrZXlWYWx1ZVNlY3Rpb24iLCJrZXkiLCJ2YWx1ZSIsIlJvdXRlciIsIltvYmplY3QgT2JqZWN0XSIsInN1cGVyIiwidGhpcyIsInJlc2V0Iiwid2luZG93IiwiYWRkRXZlbnRMaXN0ZW5lciIsInVwZGF0ZSIsInJlc29sdmVUcmVlIiwicm91dGVEaWN0aW9uYXJ5IiwicGFyZW50Q29udGFpbmVyIiwicGFyYW1IYXNoIiwiY3VycmVudE5vZGUiLCJjbGVhbnVwIiwicm91dGVzIiwiY29tcG9uZW50Iiwib3B0aW9ucyIsInJvdXRlc1ZhbGlkIiwiQXJyYXkiLCJpc0FycmF5IiwiaSIsImluZGV4T2YiLCJFcnJvciIsImV4dGVuZHNDb21wb25lbnQiLCJjdXJyZW50UHJvdG90eXBlIiwiX19wcm90b19fIiwicm91dGVPYmplY3QiLCJjdXJyZW50UmVzb2x2ZU5vZGUiLCJvIiwibm9kZVZhbHVlIiwidG9Mb3dlckNhc2UiLCJyZWdleE1hdGNoIiwiZXhlYyIsInJlc29sdmVkUmVnZXgiLCJyb3V0ZVBhcmFtTmFtZXMiLCJyb3V0ZVBhcmFtU2VjdGlvbnMiLCJsYXN0U3BsaWNlSW5kZXgiLCJub2RlVmFsdWVTZWN0aW9uIiwicHVzaCIsImdyb3VwSWQiLCJvcHRpb25hbCIsIm9wdGlvbmFsSW5kZXgiLCJncm91cFNlY3Rpb25zIiwicmVnZXhTdHIiLCJvcHRpb25hbENoYXJQb3NpdGlvbiIsInJlcXVpcmVkIiwic3Vic3RyIiwiX3JlZ2V4Tm9kZXMiLCJwYXJlbnQiLCJSZWdFeHAiLCJfcm91dGVQYXJhbU5hbWVzIiwiX3JvdXRlUGFyYW1TZWN0aW9ucyIsIl9wYXJlbnQiLCJfbm9kZU5hbWUiLCJ0aXRsZSIsImluc3RhbmNlIiwicmV0IiwiZGV0YWNoIiwiaGFuZGxlciIsImFzeW5jIiwicHJvY2VzcyIsImN1cnJlbnRDb21wb25lbnQiLCJwcmVSZW5kZXJBc3luYyIsInBhcmFtcyIsImF0dGFjaCIsImRvY3VtZW50IiwicmVuZGVyQXN5bmMiLCJiaW5kIiwicmVuZGVyIiwiUHJvbWlzZSIsInJlc29sdmUiLCJpbmxpbmVVcGRhdGUiLCJ1cGRhdGVQYXJhbXNBc3luYyIsInVwZGF0ZVBhcmFtcyIsIl9vcHRpb25zIiwiY29udGFpbmVyIiwic2VsZWN0IiwibG9jYXRpb24iLCJwYXRobmFtZSIsInNlYXJjaCIsInJlc29sdmVkIiwibmV3SGFzaCIsIm5vZGUiLCJpbmxpbmVQYXJhbXMiLCJlbWl0Iiwicm91dGVTZWN0aW9ucyIsImN1cnJlbnRQYXRoIiwiY3VycmVudFBhdGhUb0xvd2VyQ2FzZSIsIm4iLCJpZCIsInJlc29sdmVkUm91dGUiLCJwYXJhbUtleXMiLCJPYmplY3QiLCJrZXlzIiwibWlzc2luZ1RocmVzaG9sZCIsIm1pc3NpbmdDb3VudCIsInByb2R1Y3Rpb24iLCJ1cmkiLCJwcmVMaW5rUmVzb2x2ZSIsInByZUxpbmtSZXNvbHZlQXN5bmMiLCJ1c2VkUGFyYW1zIiwic2VjdGlvblZhbHVlIiwiZW5jb2RlVVJJQ29tcG9uZW50IiwidW5zaGlmdCIsImpvaW4iLCJxdWVyeVN0cmluZ1NlY3Rpb25zIiwicG9zdExpbmtSZXNvbHZlIiwicG9zdExpbmtSZXNvbHZlQXN5bmMiLCJsaW5rIiwiaGlzdG9yeSIsInB1c2hTdGF0ZSIsImhyZWYiLCJtb2R1bGUiLCJleHBvcnRzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFPQSxTQUFTSyxZQUFULENBQXNCQyxDQUF0QixFQUFzQkE7QUFDbEIsU0FBT0EsRUFBSUMsT0FBSkQsQ0FBWSxxQ0FBWkEsRUFBbUQsTUFBbkRBLENBQVA7QUFNSixVQUFTSSxvQkFBVCxDQUE4QkMsQ0FBOUIsRUFBOEJBO0FBQzFCLE1BQUlDLElBQVFELEVBQU1DLEtBQU5ELENBQVlGLHFCQUFaRSxDQUFaO0FBQUEsTUFDSUUsSUFBc0JELElBQVFBLEVBQU1FLEtBQU5GLEdBQWMsQ0FBdEJBLEdBQTBCRCxFQUFNSSxNQUQxRDtBQUFBLE1BRUlDLElBQUFBLENBQWVMLEVBQU1NLEtBQU5OLENBQVksQ0FBWkEsRUFBZUUsQ0FBZkYsQ0FBZkssRUFBb0RMLEVBQU1NLEtBQU5OLENBQVlFLElBQXNCLENBQWxDRixFQUFxQ0EsRUFBTUksTUFBM0NKLENBQXBESyxDQUZKLENBSUEsT0FBQSxFQUNJRSxNQUFNRixFQUFZLENBQVpBLElBQWlCQSxFQUFZLENBQVpBLEVBQWVHLEtBQWZILENBQXFCLEdBQXJCQSxFQUEwQkksTUFBMUJKLENBQWlDLENBQWpDQSxFQUFvQ0ssR0FBcENMLENBQXdDTTtBQUFBQSxhQUNwREMsbUJBQW1CRCxDQUFuQkMsQ0FEb0REO0FBQUFBLEtBQXhDTixDQUFqQkEsR0FFRCxJQUhULEVBSUlRLE9BQU9SLEVBQVksQ0FBWkEsSUFBaUJBLEVBQVksQ0FBWkEsRUFBZUcsS0FBZkgsQ0FBcUIsR0FBckJBLEVBQTBCSyxHQUExQkwsQ0FBOEJNLGFBQUFBO0FBQ2xELFVBQU1HLElBQWtCSCxFQUFRSCxLQUFSRyxDQUFjLEdBQWRBLENBQXhCLENBRUEsT0FBQSxFQUNJSSxLQUFLSCxtQkFBbUJFLEVBQWdCLENBQWhCQSxDQUFuQkYsQ0FEVCxFQUVJSSxPQUFBQSxDQUFPRixFQUFnQixDQUFoQkEsQ0FBUEUsSUFBNEJKLG1CQUFtQkUsRUFBZ0IsQ0FBaEJBLENBQW5CRixDQUZoQyxFQUFBO0FBRW1FLEtBTC9DUCxDQUFqQkEsR0FPRixJQVhULEVBQUE7QUFqQkosS0FBTWhCLFlBQVlDLFFBQVEsZ0JBQVJBLENBQWxCO0FBQUEsSUFDSUMsU0FBU0QsUUFBUSxhQUFSQSxDQURiO0FBQUEsSUFFSUUsYUFBYUYsUUFBUSxpQkFBUkEsQ0FGakI7QUFBQSxJQUdJRyxVQUFVSCxRQUFRLGNBQVJBLENBSGQsQ0FTQSxJQUFJTyxzQkFBc0IsVUFBMUI7QUFBQSxJQUNJQyx3QkFBd0IsWUFENUI7SUF1Qk1tQixNOzs7QUFDRkMsb0JBQUFBO0FBQUFBOztBQUFBQTs7QUFDSUMsdUhBQ0FDLE1BQUtDLEtBQUxELEVBREFELEVBRUFHLE9BQU9DLGdCQUFQRCxDQUF3QixVQUF4QkEsRUFBb0MsWUFBQTtBQUNoQ0YsWUFBS0ksTUFBTEo7QUFBS0ksS0FEVEYsRUFDU0UsQ0FDTixDQUZIRixDQUZBSCxDQURKRDtBQVFBQTs7Ozs0QkFBQUE7QUFDSUUsV0FBS0ssV0FBTEwsR0FBS0ssRUFBTEwsRUFDQUEsS0FBS00sZUFBTE4sR0FBS00sRUFETE4sRUFFQUEsS0FBS08sZUFBTFAsR0FBdUIsSUFGdkJBLEVBR0FBLEtBQUtRLFNBQUxSLEdBQWlCLElBSGpCQSxFQUtJQSxLQUFLUyxXQUFMVCxJQUFvQkEsS0FBS1MsV0FBTFQsQ0FBaUJVLE9BQXJDVixJQUNBQSxLQUFLUyxXQUFMVCxDQUFpQlUsT0FBakJWLEVBTkpBLEVBU0FBLEtBQUtTLFdBQUxULEdBQW1CLElBVG5CQTtBQVlKRjs7OzZCQUFTYSxDLEVBQVFDLEMsRUFBV0M7QUFBQUE7O0FBQUFBLFVBQUFBLENBQUFBLHVFQUFBQSxFQUFBQTtBQUt4QixVQUpzQixZQUFBLE9BQVhGLENBQVcsS0FDbEJBLElBQUFBLENBQVVBLENBQVZBLENBRGtCLEdBQ1JBLE9BR2QsRUFBNkI7QUFDekIsWUFBSUcsS0FBQUEsQ0FBYyxDQUFsQixDQUVBLElBQUlILEtBQ0lJLE1BQU1DLE9BQU5ELENBQWNKLENBQWRJLENBRFIsRUFDK0I7QUFDdkJELGVBQUFBLENBQWMsQ0FBZEEsQ0FDQSxLQUFLLElBQUlHLEtBQUksQ0FBYixFQUFnQkEsS0FBSU4sRUFBTzNCLE1BQVhpQyxJQUFxQkgsRUFBckMsRUFBa0RHLElBQWxEO0FBQ0lILGlCQUFtQyxZQUFBLE9BQWRILEVBQU9NLEVBQVBOLENBQWMsSUFBdUMsTUFBM0JBLEVBQU9NLEVBQVBOLEVBQVVPLE9BQVZQLENBQWtCLEdBQWxCQSxDQUEvQ0c7QUFESjtBQU1SLGFBQUEsQ0FBS0EsRUFBTCxFQUNJLE1BQU0sSUFBSUssS0FBSix1RUFBOEVSLENBQTlFLE9BQU4sQ0FHSixJQUFJUyxJQUFBQSxDQUFtQixDQUF2QjtBQUFBLFlBQ0lDLElBQW1CVCxFQUFVVSxTQURqQyxDQUVBLE9BQUEsQ0FBUUYsQ0FBUixJQUFnRCxRQUFwQkMsQ0FBNUI7QUFDUUEsZ0JBQXFCcEQsU0FBckJvRCxHQUNBRCxJQUFBQSxDQUFtQixDQURuQkMsR0FJQUEsSUFBbUJBLEVBQWlCQyxTQUpwQ0Q7QUFEUjtBQWNKO0FBckN3QlIsaUNBcUNmSSxFQXJDZUo7QUFzQ3BCLFlBQUlVLElBQWM1QyxxQkFBcUJnQyxFQUFPTSxFQUFQTixDQUFyQmhDLENBQWxCLENBRUEsSUFBQSxPQUFBLEVBQTZCO0FBQ3pCLGNBQUEsQ0FBSzRDLENBQUwsRUFDSSxNQUFNLElBQUlKLEtBQUosNkNBQW9EUixFQUFPTSxFQUFQTixDQUFwRCxPQUFOLENBRUMsSUFBSVksRUFBWTlCLEtBQVo4QixJQUFxQkEsRUFBWTlCLEtBQVo4QixDQUFrQnZDLE1BQWxCdUMsR0FBMkIsQ0FBcEQsRUFDRCxNQUFNLElBQUlKLEtBQUosZ0VBQXVFUixFQUFPTSxFQUFQTixDQUF2RSxrQ0FBTjtBQUlSLGFBQUlhLElBQXFCeEIsT0FBS0ssV0FBOUIsQ0FDQSxLQUFLLElBQUlvQixNQUFJLENBQWIsRUFBZ0JBLE1BQUlGLEVBQVlwQyxJQUFab0MsQ0FBaUJ2QyxNQUFyQyxFQUE2Q3lDLEtBQTdDLEVBQWtEO0FBQzlDLGNBQUlDLE1BQVlILEVBQVlwQyxJQUFab0MsQ0FBaUJFLEdBQWpCRixFQUFvQkksV0FBcEJKLEVBQWhCO0FBQUEsY0FDSUssS0FBYW5ELG9CQUFvQm9ELElBQXBCcEQsQ0FBeUJpRCxHQUF6QmpELENBRGpCLENBR0EsSUFBSW1ELEVBQUosRUFBZ0I7QUFDWixnQkFLSU0sWUFMSjtBQUFBLGdCQUFJSixLQUFnQixFQUFwQjtBQUFBLGdCQUNJQyxJQUFBQSxFQURKO0FBQUEsZ0JBRUlDLElBQUFBLEVBRko7QUFBQSxnQkFJSUMsSUFBa0IsQ0FKdEIsQ0FNQSxHQUFHO0FBRUNILG9CQUFpQnhELGFBRGpCNEQsTUFBbUJSLElBQVV4QyxLQUFWd0MsQ0FBZ0JPLENBQWhCUCxFQUFpQ0UsR0FBVzdDLEtBQTVDMkMsQ0FDRnBELENBQWpCd0QsRUFDQUUsRUFBbUJHLElBQW5CSCxDQUF3QkUsR0FBeEJGLENBREFGLENBR0EsSUFBSU0sS0FBVVIsR0FBVyxDQUFYQSxDQUFkO0FBQUEsa0JBQ0lTLEtBQUFBLENBQVcsQ0FEZjtBQUFBLGtCQUVJQyxJQUFnQkYsR0FBUWxCLE9BQVJrQixDQUFnQixHQUFoQkEsQ0FGcEIsQ0FJQSxJQUFLQyxLQUFBQSxDQUErQixDQUEvQkEsS0FBWUMsQ0FBakIsRUFBeUM7QUFDckMsb0JBQUEsV0FDUUEsTUFBa0JGLEdBQVFwRCxNQUFSb0QsR0FBaUIsQ0FEM0MsRUFFUSxNQUFNLElBQUlqQixLQUFKLHFDQUE0Q1IsRUFBT00sRUFBUE4sQ0FBNUMsd0VBQU4sQ0FJUnlCLEtBQVVBLEdBQVFsRCxLQUFSa0QsQ0FBYyxDQUFkQSxFQUFpQkEsR0FBUXBELE1BQVJvRCxHQUFpQixDQUFsQ0EsQ0FBVkE7QUFHSixtQkFBSUcsSUFBZ0JILEdBQVFoRCxLQUFSZ0QsQ0FBYyxHQUFkQSxDQUFwQjtBQUFBLGtCQUNJSSxJQUFXLElBRGYsQ0FHQUosS0FBVUcsRUFBYyxDQUFkQSxDQUFWSCxFQUV3QixRQUFwQkcsRUFBYyxDQUFkQSxDQUFvQixLQUNwQkEsRUFBYyxDQUFkQSxJQUFtQixLQURDLENBRnhCSCxDQU1BLElBQ0lNLFVBREo7QUFBQSxrQkFBSUQsSUFBdUJMLEdBQVFsQixPQUFSa0IsQ0FBZ0IsR0FBaEJBLENBQTNCLENBT0EsUUFBQSxDQUpLTSxJQUFXRCxNQUF5QkwsR0FBUXBELE1BQVJvRCxHQUFpQixDQUkxRCxNQUhJQSxLQUFVQSxHQUFRTyxNQUFSUCxDQUFlLENBQWZBLEVBQWtCSyxDQUFsQkwsQ0FHZCxHQUFRRyxFQUFjLENBQWRBLENBQVIsR0FDSSxLQUFLLFFBQUw7QUFDSUMsaUNBQW1CRSxJQUFXLEdBQVhBLEdBQWlCLEdBQXBDRixRQUNBLE1BQ0osS0FBSyxLQUFMLENBQ0EsS0FBSyxRQUFMO0FBQ0lBLDhCQUFnQkUsSUFBVyxHQUFYQSxHQUFpQixHQUFqQ0YsUUFDQSxNQUNKO0FBQ0ksc0JBQUEsT0FBQSxFQUNJLE1BQU0sSUFBSXJCLEtBQUoseUNBQWdEUixFQUFPTSxFQUFQTixDQUFoRCxXQUErRDRCLEVBQWMsQ0FBZEEsQ0FBL0QsQ0FBTixDQVZaLENBZUFULE1BQWlCVSxDQUFqQlYsRUFFSU8sT0FDQVAsTUFBaUIsR0FEakJPLENBRkpQLEVBTUFDLEVBQWdCSSxJQUFoQkosQ0FBcUJLLEVBQXJCTCxDQU5BRCxFQU9BRyxJQUFrQkwsR0FBVzdDLEtBQVg2QyxHQUFtQkEsR0FBVyxDQUFYQSxFQUFjNUMsTUFQbkQ4QztBQU9tRDlDLGFBekR2RCxRQTBEK0QsU0FBckQ0QyxLQUFhbkQsb0JBQW9Cb0QsSUFBcEJwRCxDQUF5QmlELEdBQXpCakQsQ0FBd0MsQ0ExRC9ELEVBNERBeUQsTUFBbUJSLElBQVV4QyxLQUFWd0MsQ0FBZ0JPLENBQWhCUCxDQUFuQlEsRUFDQUYsRUFBbUJHLElBQW5CSCxDQUF3QkUsR0FBeEJGLENBREFFLEVBRUFKLE1BQWlCeEQsYUFBYTRELEdBQWI1RCxDQUZqQjRELEVBSUtWLEVBQW1Cb0IsV0FBbkJwQixLQUNEQSxFQUFtQm9CLFdBQW5CcEIsR0FBbUJvQixFQURsQnBCLENBSkxVLENBUUEsSUFBSVcsSUFBU3JCLENBQWIsQ0FDQUEsRUFBbUJvQixXQUFuQnBCLENBQStCVyxJQUEvQlgsQ0FBb0NBLElBQXFCLElBQUlzQixNQUFKLENBQVdoQixFQUFYLENBQXpETixHQUNBQSxFQUFtQnVCLGdCQUFuQnZCLEdBQXNDTyxDQUR0Q1AsRUFFQUEsRUFBbUJ3QixtQkFBbkJ4QixHQUF5Q1EsQ0FGekNSLEVBR0FBLEVBQW1CeUIsT0FBbkJ6QixHQUE2QnFCLENBSDdCckI7QUFHNkJxQixXQS9FakMsTUFrRlNyQixFQUFtQkUsR0FBbkJGLE1BQ0RBLEVBQW1CRSxHQUFuQkYsSUFBbUJFLEVBQ2Z1QixTQUFTekIsQ0FETUUsRUFFZndCLFdBQVd4QixHQUZJQSxFQURsQkYsR0FNTEEsSUFBcUJBLEVBQW1CRSxHQUFuQkYsQ0FOaEJBO0FBVVUscUJBQUEsT0FBWlgsQ0FBWSxJQUNBLGNBQUEsT0FBWkEsQ0FEWSxLQUVuQkEsSUFBQUEsRUFDSXNDLE9BQU90QyxDQURYQSxFQUZtQixFQU92QixJQUFJdUMsSUFBVyxJQUFmLENBQ0F2QyxFQUFRSCxPQUFSRyxHQUFrQixZQUFBO0FBQ2QsY0FBSXdDLElBQU1ELEVBQVNFLE1BQVRGLEVBQVYsQ0FNQSxPQUpJQyxNQUNBRCxJQUFXLElBRFhDLEdBSUdBLENBQVA7QUFBT0EsU0FQWHhDLEVBVUFBLEVBQVEwQyxPQUFSMUM7QUFBQUEsNkVBQWtCMkMsaUJBQUFBLENBQUFBO0FBQUFBO0FBQUFBO0FBQUFBO0FBQUFBO0FBQUFBO0FBQ2RKLHdCQUFXLElBQUl4QyxDQUFKLEVBREc0QztBQUdUQywrQkFDRHZELE9BQU93RCxnQkFBUHhELEdBQTBCa0QsQ0FEekJLLENBSFNEO0FBQUFBLGtDQU93QixjQUFBLE9BQTNCM0MsRUFBUThDLGNBUExIOztBQUFBQTtBQUFBQTtBQUFBQTtBQUFBQTs7QUFBQUE7QUFBQUEsMkJBUUozQyxFQUFROEMsY0FBUjlDLENBQXVCdUMsQ0FBdkJ2QyxFQUFpQytDLENBQWpDL0MsQ0FSSTJDOztBQUFBQTtBQVdkSixzQkFBU1MsTUFBVFQsQ0FBZ0JwRCxPQUFLTyxlQUFyQjZDLENBWGNJO0FBYVZMLHFCQWJVSyxHQWFGM0MsRUFBUXNDLEtBYk5LO0FBZU8sa0NBQUEsT0FBVkwsQ0FBVSxLQUNqQkEsSUFBUUEsRUFBTVMsQ0FBTlQsQ0FEUyxDQWZQSztBQW1CVkwsMEJBQ0FXLFNBQVNYLEtBQVRXLEdBQWlCWCxDQURqQkEsQ0FuQlVLOztBQUFBQSwwQkF1QnFCLGNBQUEsT0FBeEIzQyxFQUFRa0QsV0F2QkxQO0FBQUFBO0FBQUFBO0FBQUFBOztBQUFBQTtBQUFBQSwyQkF3QkozQyxFQUFRa0QsV0FBUmxELENBQW9CK0MsQ0FBcEIvQyxFQUE0QnVDLEVBQVNXLFdBQVRYLENBQXFCWSxJQUFyQlosQ0FBMEJBLENBQTFCQSxDQUE1QnZDLENBeEJJMkM7O0FBQUFBO0FBQUFBO0FBQUFBOztBQUFBQTtBQUFBQSwwQkEwQnFCLGNBQUEsT0FBbkIzQyxFQUFRb0QsTUExQlZUO0FBQUFBO0FBQUFBO0FBQUFBOztBQUFBQTtBQUFBQSwyQkEyQkosSUFBSVUsT0FBSixDQUFZQyxhQUFBQTtBQUNUVixnQ0FDR0wsRUFBU0ksS0FEWkMsRUFLTDVDLEVBQVFvRCxNQUFScEQsQ0FBZStDLENBQWYvQyxFQUFlK0MsQ0FBU1IsRUFBU0ksS0FBVEosR0FBaUJBLEVBQVNXLFdBQTFCWCxHQUF3Q0EsRUFBU2EsTUFBMURMLEVBQWtFSSxJQUFsRUosQ0FBdUVSLENBQXZFUSxDQUFmL0MsQ0FMSzRDO0FBS2lGTCxxQkFOcEYsQ0EzQklJOztBQUFBQTtBQUFBQTtBQUFBQTs7QUFBQUE7QUFBQUE7QUFBQUEsMkJBcUNKSixFQUFTVyxXQUFUWCxDQUFxQlEsQ0FBckJSLENBckNJSTs7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUEsV0FBbEIzQzs7QUFBQUE7QUFBQUE7QUFBQUE7QUFBQUEsV0FWQUEsRUFtREFBLEVBQVF1RCxZQUFSdkQ7QUFBQUEsOEVBQXVCMkMsa0JBQUFBLENBQUFBO0FBQUFBO0FBQUFBO0FBQUFBO0FBQUFBO0FBQUFBLDBCQUN1QixjQUFBLE9BQS9CSixFQUFTaUIsaUJBRERiO0FBQUFBO0FBQUFBO0FBQUFBOztBQUFBQTtBQUFBQSwyQkFFVEosRUFBU2lCLGlCQUFUakIsQ0FBMkJRLENBQTNCUixDQUZTSTs7QUFBQUE7QUFBQUE7QUFBQUE7O0FBQUFBO0FBSXVCLGtDQUFBLE9BQTFCSixFQUFTa0IsWUFBaUIsSUFDdENsQixFQUFTa0IsWUFBVGxCLENBQXNCUSxDQUF0QlIsQ0FMZUk7O0FBQUFBO0FBQUFBO0FBQUFBO0FBQUFBO0FBQUFBO0FBQUFBO0FBQUFBLFdBQXZCM0M7O0FBQUFBO0FBQUFBO0FBQUFBO0FBQUFBLFdBbkRBQSxFQTREQVcsRUFBbUIrQyxRQUFuQi9DLEdBQThCWCxDQTVEOUJBLEVBOERLYixPQUFLTSxlQUFMTixDQUFxQlksQ0FBckJaLElBSURBLE9BQUtNLGVBQUxOLENBQXFCWSxDQUFyQlosRUFBZ0NtQyxJQUFoQ25DLENBQXFDd0IsQ0FBckN4QixDQUpDQSxHQUNEQSxPQUFLTSxlQUFMTixDQUFxQlksQ0FBckJaLElBQXFCWSxDQUFjWSxDQUFkWixDQS9EekJDO0FBMUpvQkE7O0FBcUN4QixXQUFLLElBQUlJLEVBQVQsSUFBY04sQ0FBZCxFQUFzQjtBQUFBLGNBQWJNLEVBQWE7QUEyTHRCLGNBQU9MLENBQVA7QUFHSmQ7OzsyQkFBTzBFLEMsRUFBQUE7QUFFSCxhQURBeEUsS0FBS08sZUFBTFAsR0FBdUI3QixPQUFPc0csTUFBUHRHLENBQWNxRyxDQUFkckcsQ0FBdkI2QixFQUNPQSxLQUFLSSxNQUFMSixFQUFQO0FBR0pGOzs7OztZQUFhWCxDLDRFQUFVZSxPQUFPd0UsUUFBUHhFLENBQWdCeUUsUSxHQUFXekUsT0FBT3dFLFFBQVB4RSxDQUFnQjBFLE07WUFBVUMsQyx1RUFBVzdFLEtBQUttRSxPQUFMbkUsQ0FBYWIsQ0FBYmEsQztBQUM5RXlELGU7Ozs7O0FBTURKLGlCLEdBQUFBLENBQU0sQzs7cUJBRU53QixDOzs7Ozs7QUFFUVQsaUIsR0FBQUEsQ0FBZSxDLEVBRWZVLEMsR0FBVTFHLFdBQVd5RyxFQUFTakIsTUFBcEJ4RixFQUFvQndGLENBQVEsQ0FBNUJ4RixFQUFtQ3lHLEVBQVNFLElBQVRGLENBQWNOLFFBQWRNLENBQXVCRyxZQUExRDVHLEM7QUFDVjRCLHFCQUFLUyxXQUFMVCxLQUFxQjZFLEVBQVNFLElBQTlCL0UsS0FDQW9FLElBQWVVLE1BQVk5RSxLQUFLUSxTQURoQ1IsQzs7cUJBSUFvRSxDOzs7Ozs7dUJBQ01wRSxLQUFLUyxXQUFMVCxDQUFpQnVFLFFBQWpCdkUsQ0FBMEJvRSxZQUExQnBFLENBQXVDNkUsRUFBU2pCLE1BQWhENUQsQzs7Ozs7OztBQUdOQSxxQkFBS1EsU0FBTFIsR0FBaUI4RSxDO0FBRWI5RSxxQkFBS1MsV0FBTFQsS0FDQXFELElBQU1yRCxLQUFLUyxXQUFMVCxDQUFpQnVFLFFBQWpCdkUsQ0FBMEJVLE9BQTFCVixFQUROQSxDOytCQUlBcUQsQzs7Ozs7OztBQUNBckQscUJBQUtTLFdBQUxULEdBQW1CNkUsRUFBU0UsSTs7dUJBRXRCL0UsS0FBS1MsV0FBTFQsQ0FBaUJ1RSxRQUFqQnZFLENBQTBCdUQsT0FBMUJ2RCxDQUFrQzZFLEVBQVNqQixNQUEzQzVELEM7Ozs7dUJBQ0FBLEtBQUtTLFdBQUxULENBQWlCdUUsUUFBakJ2RSxDQUEwQm9FLFlBQTFCcEUsQ0FBdUM2RSxFQUFTakIsTUFBaEQ1RCxDOzs7QUFJVnFELHFCQUNBckQsS0FBS2lGLElBQUxqRixDQUFVLFNBQVZBLEVBQXFCYixDQUFyQmEsQzs7Ozs7OztBQUlKQSxxQkFBS2lGLElBQUxqRixDQUFVLE9BQVZBLGlCQUVBcUQsSUFBQUEsQ0FBTSxDQUZOckQ7Ozs7Ozs7QUFNSkEscUJBQUtpRixJQUFMakYsQ0FBVSxZQUFWQSxFQUF3QmIsQ0FBeEJhLEdBRUFxRCxJQUFBQSxDQUFNLENBRk5yRDs7O2tEQUtHcUQsQzs7Ozs7Ozs7Ozs7Ozs7Ozs7OzRCQUdIbEUsQyxFQUFBQTtBQUNKLFVBQUEsV0FDZ0IsUUFBUkEsQ0FEUixFQUVRLE1BQU0sSUFBSWdDLEtBQUosQ0FBVSxzQ0FBVixDQUFOLENBSVIsSUFBSStELElBQWdCdkcscUJBQXFCUSxDQUFyQlIsQ0FBcEI7QUFBQSxVQUNJNkMsSUFBcUJ4QixLQUFLSyxXQUQ5QjtBQUFBLFVBRUl1RCxJQUFBQSxFQUZKLENBSUEsS0FBSyxJQUFJM0MsS0FBSSxDQUFiLEVBQWdCQSxLQUFJaUUsRUFBYy9GLElBQWQrRixDQUFtQmxHLE1BQXZDLEVBQStDaUMsSUFBL0MsRUFBb0Q7QUFDaEQsWUFBSWtFLE1BQWNELEVBQWMvRixJQUFkK0YsQ0FBbUJqRSxFQUFuQmlFLENBQWxCLENBRUEsSUFBSUMsR0FBSixFQUNJLElBQUlDLElBQXlCRCxJQUFZeEQsV0FBWndELEVBQTdCLENBR0osSUFBa0QsUUFBOUMzRCxFQUFtQjRELENBQW5CNUQsQ0FBSixFQUNJQSxJQUFxQkEsRUFBbUI0RCxDQUFuQjVELENBQXJCQSxDQURKLEtBR0s7QUFBQSxjQUFBLENBQUlBLEVBQW1Cb0IsV0FBdkIsRUFvQkQsT0FBTyxJQUFQLENBcEJxQztBQUNyQyxnQkFBSS9ELE1BQVEsSUFBWixDQUNBLEtBQUssSUFBSTRDLE1BQUksQ0FBYixFQUFnQkEsTUFBSUQsRUFBbUJvQixXQUFuQnBCLENBQStCeEMsTUFBbkQsRUFBMkR5QyxLQUEzRDtBQUVJLGtCQURBNUMsTUFBUTJDLEVBQW1Cb0IsV0FBbkJwQixDQUErQkMsR0FBL0JELEVBQWtDSyxJQUFsQ0wsQ0FBdUMyRCxHQUF2QzNELENBQ1IsRUFBVztBQUNQQSxvQkFBcUJBLEVBQW1Cb0IsV0FBbkJwQixDQUErQkMsR0FBL0JELENBQXJCQSxDQUVBLEtBQUssSUFBSTZELE1BQUksQ0FBYixFQUFnQkEsTUFBSTdELEVBQW1CdUIsZ0JBQW5CdkIsQ0FBb0N4QyxNQUF4RCxFQUFnRXFHLEtBQWhFO0FBQ0l6QixvQkFBT3BDLEVBQW1CdUIsZ0JBQW5CdkIsQ0FBb0M2RCxHQUFwQzdELENBQVBvQyxJQUFpRC9FLElBQU13RyxNQUFJLENBQVZ4RyxDQUFqRCtFO0FBREosaUJBSUE7QUFJUjtBQWJBLGFBYUEsSUFBQSxDQUFLL0UsR0FBTCxFQUNJLE9BQU8sSUFBUDtBQUFPO0FBQUE7QUFRbkIsV0FBSXdFLElBQU0sSUFBVixDQUNBLElBQUk3QixFQUFtQitDLFFBQXZCLEVBQWlDO0FBQzdCLFlBQUlXLEVBQWN6RixLQUFkeUYsSUFBdUJBLEVBQWN6RixLQUFkeUYsQ0FBb0JsRyxNQUEvQyxFQUNJLEtBQUssSUFBSWlDLE1BQUksQ0FBYixFQUFnQkEsTUFBSWlFLEVBQWN6RixLQUFkeUYsQ0FBb0JsRyxNQUF4QyxFQUFnRGlDLEtBQWhEO0FBQ0kyQyxZQUFPc0IsRUFBY3pGLEtBQWR5RixDQUFvQmpFLEdBQXBCaUUsRUFBdUJ2RixHQUE5QmlFLElBQXFDc0IsRUFBY3pGLEtBQWR5RixDQUFvQmpFLEdBQXBCaUUsRUFBdUJ0RixLQUE1RGdFO0FBREosU0FLSlAsSUFBQUEsRUFDSTBCLE1BQU12RCxDQURWNkIsRUFFSU8sUUFBUUEsQ0FGWlAsRUFBQUE7QUFNSixjQUFPQSxDQUFQO0FBR0p2RDs7Ozs0RkFBV3dGLEM7WUFBSTFCLEMsdUVBQUFBLEU7Ozs7Ozs7Ozs7Ozs7c0JBRUcsUUFBTjBCLEM7Ozs7O3NCQUNNLElBQUluRSxLQUFKLENBQVUsb0NBQVYsQzs7O3NCQUUyQixRQUE1Qm5CLEtBQUtNLGVBQUxOLENBQXFCc0YsQ0FBckJ0RixDOzs7OztzQkFDQyxJQUFJbUIsS0FBSixvQ0FBMkNtRSxDQUEzQyxPOzs7QUFJVjNFLGlCLEdBQVNYLEtBQUtNLGVBQUxOLENBQXFCc0YsQ0FBckJ0RixDLEVBQ1R1RixDLEdBQWdCLEksRUFDaEJDLEMsR0FBWUMsT0FBT0MsSUFBUEQsQ0FBWTdCLENBQVo2QixDLEVBQ1pFLEMsR0FBbUIsSTtBQUt2QixxQkFBUzFFLEdBQVQsR0FBYSxDQUFiLEVBQWdCQSxNQUFJTixFQUFPM0IsTUFBM0IsRUFBbUNpQyxLQUFuQyxFQUF3QztBQUNoQzJFLHFCQURnQztBQUVwQyxzQkFBSWpGLEVBQU9NLEdBQVBOLEVBQVVvQyxnQkFBZCxFQUFnQztBQUM1QjZDLDBCQUFlLENBQWZBLENBQ0EsS0FBU25FLEdBQVQsR0FBYSxDQUFiLEVBQWdCQSxNQUFJZCxFQUFPTSxHQUFQTixFQUFVb0MsZ0JBQVZwQyxDQUEyQjNCLE1BQS9DLEVBQXVEeUMsS0FBdkQ7QUFBdURBLHVCQUNPLENBRFBBLEtBQy9DK0QsRUFBVXRFLE9BQVZzRSxDQUFrQjdFLEVBQU9NLEdBQVBOLEVBQVVvQyxnQkFBVnBDLENBQTJCYyxHQUEzQmQsQ0FBbEI2RSxDQUQrQy9ELElBRS9DbUUsS0FGK0NuRTtBQUF2RDtBQUVRbUUsbUJBSlosTUFTSUEsTUFBZUosRUFBVXhHLE1BQXpCNEcsQ0FBeUI1RyxDQUd6QjRHLE1BQWVELENBQWZDLElBQXVELFFBQXBCRCxDQUhWM0csTUFJekJ1RyxJQUFnQjVFLEVBQU9NLEdBQVBOLENBQWhCNEUsRUFDQUksSUFBbUJDLEdBTE01RztBQVNqQztzQkFBQSxXQUFpQjZHLENBQ1JOLEM7Ozs7O3NCQUNLLElBQUlwRSxLQUFKLHlDQUFnRG1FLENBQWhELE87OztBQUlWUSxpQixHQUFNLEk7QUFDMkMsOEJBQUEsT0FBMUNQLEVBQWNoQixRQUFkZ0IsQ0FBdUJRLGNBQW1CLEtBQ2pERCxJQUFNUCxFQUFjaEIsUUFBZGdCLENBQXVCUSxjQUF2QlIsQ0FBc0MzQixDQUF0QzJCLENBRDJDLEM7K0JBSUssY0FBQSxPQUEvQ0EsRUFBY2hCLFFBQWRnQixDQUF1QlMsbUI7Ozs7Ozs7O3VCQUNsQlQsRUFBY2hCLFFBQWRnQixDQUF1QlMsbUJBQXZCVCxDQUEyQzNCLENBQTNDMkIsQzs7O0FBQVpPLGlCOzs7b0JBR0NBLEM7Ozs7O0FBQ0dyRixtQixHQUFjOEUsQyxFQUVkdEcsRyxHQUFBQSxFLEVBQ0FnSCxHLEdBQUFBLEVBQ0lqSCxRQUFRLENBRFppSCxFO0FBR0osdUJBQThCLFFBQXZCeEYsSUFBWXdDLE9BQW5CLEdBQW9DO0FBQ2hDLHNCQUFJeEMsZUFBdUJxQyxNQUEzQixFQUFtQztBQUMzQm9ELHVCQUQyQixHQUNaLEVBRFksRUFFM0JqRixHQUYyQixHQUV2QixDQUZ1QjtBQUcvQiwyQkFBT0EsTUFBSVIsSUFBWXNDLGdCQUFadEMsQ0FBNkJ6QixNQUF4QyxFQUFnRGlDLEtBQWhEO0FBQ1EyQyx3QkFBT25ELElBQVlzQyxnQkFBWnRDLENBQTZCUSxHQUE3QlIsQ0FBUG1ELE1BQ0FzQyxZQUFtQnpGLElBQVl1QyxtQkFBWnZDLENBQWdDUSxHQUFoQ1IsQ0FBbkJ5RixHQUF3RHRDLEVBQU9uRCxJQUFZc0MsZ0JBQVp0QyxDQUE2QlEsR0FBN0JSLENBQVBtRCxDQUF4RHNDLEVBQ0FELElBQVd4RixJQUFZc0MsZ0JBQVp0QyxDQUE2QlEsR0FBN0JSLENBQVh3RixJQUF3Q2hGLENBQU0sQ0FEOUNpRixFQUVBRCxJQUFXakgsTUFBWGlILEVBSEFyQztBQURSLHFCQVFBM0UsSUFBWWtELElBQVpsRCxDQUFpQmtILHdCQUFzQkQsR0FBdEJDLEdBQXFDMUYsSUFBWXVDLG1CQUFadkMsQ0FBZ0NRLEdBQWhDUixDQUFyQzBGLENBQWpCbEg7QUFBc0ZnQyxtQkFYMUYsTUFjSWhDLElBQVltSCxPQUFabkgsQ0FBb0JrSCxtQkFBbUIxRixJQUFZeUMsU0FBL0JpRCxDQUFwQmxILEVBR0p3QixNQUFjQSxJQUFZd0MsT0FBMUJ4QztBQUdKcUYsMkJBQVU3RyxJQUFZb0gsSUFBWnBILENBQWlCLEdBQWpCQSxDQUFWNkcsQ0FFSVEsQyxHQUFBQSxFO0FBRUosb0JBQUlMLElBQVdqSCxNQUFYaUgsR0FBb0JULEVBQVV4RyxNQUFsQyxFQUEwQztBQUN0Qyx1QkFBU2lDLEdBQVQsR0FBYSxDQUFiLEVBQWdCQSxNQUFJdUUsRUFBVXhHLE1BQTlCLEVBQXNDaUMsS0FBdEM7QUFDU2dGLHdCQUFXVCxFQUFVdkUsR0FBVnVFLENBQVhTLEtBQ0RLLEVBQW9CbkUsSUFBcEJtRSxDQUE0QkgsbUJBQW1CWCxFQUFVdkUsR0FBVnVFLENBQW5CVyxDQUE1QkcsU0FBZ0VILG1CQUFtQnZDLEVBQU80QixFQUFVdkUsR0FBVnVFLENBQVA1QixDQUFuQnVDLENBQWhFRyxDQURDTDtBQURULG1CQU1JSyxFQUFvQnRILE1BQXBCc0gsR0FBNkIsQ0FBN0JBLEtBQ0FSLFdBQVdRLEVBQW9CRCxJQUFwQkMsQ0FBeUIsR0FBekJBLENBRFhBO0FBSzhDLCtCQUFBLE9BQTNDZixFQUFjaEIsUUFBZGdCLENBQXVCZ0IsZUFBb0IsS0FDbERULElBQU1QLEVBQWNoQixRQUFkZ0IsQ0FBdUJnQixlQUF2QmhCLENBQXVDM0IsQ0FBdkMyQixFQUErQ08sQ0FBL0NQLENBRDRDLEM7K0JBSUssY0FBQSxPQUFoREEsRUFBY2hCLFFBQWRnQixDQUF1QmlCLG9COzs7Ozs7Ozt1QkFDbEJqQixFQUFjaEIsUUFBZGdCLENBQXVCZ0IsZUFBdkJoQixDQUF1QzNCLENBQXZDMkIsRUFBK0NPLENBQS9DUCxDOzs7QUFBWk8saUI7OztrREFJREEsQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs0RkFHQVIsQztZQUFJMUIsQyx1RUFBQUEsRTs7Ozs7Ozs7O3VCQUNPNUQsS0FBS3lHLElBQUx6RyxDQUFVc0YsQ0FBVnRGLEVBQWM0RCxDQUFkNUQsQzs7O0FBQVo4RixpQjs7cUJBRUY5RixLQUFLTyxlOzs7OztBQUNEc0UsbUI7O3NCQUNBaUIsV0FBVzVGLE9BQU93RSxRQUFQeEUsQ0FBZ0J5RSxRQUEzQm1CLEdBQXNDNUYsT0FBT3dFLFFBQVB4RSxDQUFnQjBFLE07Ozs7Ozt1QkFDaEQ1RSxLQUFLSSxNQUFMSixDQUFZOEYsQ0FBWjlGLEM7Ozs7Ozs7c0JBRUE2RSxNQUFXN0UsS0FBS21FLE9BQUxuRSxDQUFhOEYsQ0FBYjlGLEM7Ozs7Ozt1QkFDUEEsS0FBS0ksTUFBTEosQ0FBWThGLENBQVo5RixFQUFpQjZFLEdBQWpCN0UsQzs7Ozs7Ozs7OztBQUNOMEcsd0JBQVFDLFNBQVJELENBQWtCOUMsQ0FBbEI4QyxFQUEwQixFQUExQkEsRUFBOEJaLENBQTlCWSxDOzs7Ozs7O0FBSUp4Ryx1QkFBT3dFLFFBQVB4RSxDQUFnQjBHLElBQWhCMUcsR0FBdUI0RixDOzs7Ozs7O0FBSTNCNUYsdUJBQU93RSxRQUFQeEUsQ0FBZ0IwRyxJQUFoQjFHLEdBQXVCNEYsQ0FBdkI1Rjs7Ozs7Ozs7Ozs7Ozs7Ozs7O0VBbGZTN0IsTzs7QUF1ZnJCd0ksT0FBT0MsT0FBUEQsR0FBaUIsSUFBSWhILE1BQUosRUFBakJnSCJ9